import { List } from 'immutable'
import * as actions from './actions'
import Location from './Location'
import { Record } from '../transit'
import { ListMeta } from '../lib/redux-lists'

const State = Record({
  meta: new ListMeta(),
  all: new List(),
  current: new Location(),
  lastSelectedId: '',
}, 'locations')

const locationsReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.LOCATIONS_LOAD_SUCCESS: {
      const locations = List(action.payload.data.map(json => new Location(json)))
      return state.set('all', locations).set('meta', new ListMeta(action.payload.meta))
    }
	case actions.LOCATIONS_LOAD_ACTIVE_SUCCESS: {
      const locations = List(action.payload.data.map(json => new Location(json)))
      return state.set('all', locations).set('meta', new ListMeta(action.payload.meta))
    }
    case actions.LOCATION_LOAD_SUCCESS: {
      const location = new Location(action.payload.data)
      return state.set('current', location)
    }
    case actions.LOCATION_CREATE_SUCCESS: {
      const location = new Location(action.payload.data)
      return state.set('current', location)
    }
    case actions.LOCATION_UPDATE_SUCCESS: {
      const location = new Location(action.payload.data)
      return state.set('current', location)
    }
    case actions.LOCATION_DELETE_SUCCESS: {
      const list = state.get('all')
      const { _id } = action.payload.data
      const index = list.findIndex((item) => item._id === _id)
      return state.set('all', list.remove(index))
    }
    case actions.LOCATION_SET_LAST_SELECTED: {
      const { id } = action.payload
      return state.set('lastSelectedId', id)
    }
    case actions.CLEAR_LOCATIONS: {
      return state.set('all', new List()).set('meta', new ListMeta())
    }
    case actions.CLEAR_LOCATION: {
      return state.set('current', new Location())
    }
    default:
      return state
  }
}

export default locationsReducer



// WEBPACK FOOTER //
// ./src/common/locations/reducer.js